<script>
    import store from "../store"

    export default {
        name: "Permisssions",

        methods: {
            can: function(permission) {

                if (store.state.permissions)
                    return store.state.permissions.indexOf(permission) !== -1;

                return false;

            },
        },
    }
</script>
